module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"review_detail_title":"View review details"}}')
  delete Component.options._Ctor
}
